import { render, staticRenderFns } from "./OrderColumn.vue?vue&type=template&id=152a0426&"
import script from "./OrderColumn.vue?vue&type=script&lang=ts&"
export * from "./OrderColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports